export const FETCH_SUBSCRIBER_ADDRESS = 'subscriber/:id/address';
